import request from '@/utils/request'

// 通过服务项目-查询订单列表
export const listAppointmentOrder = (pageData, formData) => {
    return request.post(`/appointment/order/page/${formData.serviceItemId}/${pageData.page}/${pageData.pageSize}`, formData);
};

// 修改订单
export const editAppointmentOrder = (updateData) => {
    return request.put(`/appointment/order/${updateData.orderId}`, updateData)
}
